<template>
    <van-popup
        v-model="active"
        round
        safe-area-inset-bottom
        class="wechat-tips-for-ios"
        position="bottom"
        @click-overlay="close"
    >
        <img class="img" :src="require('@/assets/imgs/common/share1.gif')" />

        <div class="main">
            <div>请使用safari浏览器打开链接</div>
            <div style="margin-bottom: 15px">
                安装
                <span style="color: red">{{ name }}</span>
                到桌面即可体验游戏
            </div>
            <van-button size="large" style="border-radius: 10px" type="info" @click="copyh5GameUrl(copyUrl)">
                复制链接
            </van-button>
        </div>
    </van-popup>
</template>

<script lang="ts">
import clipboard from 'clipboard-js'
import { Popup, Swipe, SwipeItem } from 'vant'
import { Component } from 'vue-property-decorator'

import BaseComponent from '@/BaseComponent'

/**
 *
 * @author
 * @create 2021-11-26 (星期五)
 */
@Component({ name: 'wechat-tips-for-ios', components: { Swipe, SwipeItem, Popup } })
export default class extends BaseComponent {
    /* props, data, getter */
    /**  */
    active: boolean = false
    callback!: Function
    name: string = ''
    copyUrl: string = ''
    /* life event: [mounted, beforeDestory] */
    /* methods */
    /** 打开 */
    async open(name: string): Promise<void> {
        return new Promise((resolve) => {
            this.active = true
            this.callback = resolve
            this.name = name

            this.copyUrl = window.location.origin + '/iosInstall/' + this.$route.params.shortChain
        })
    }

    /** 关闭 */
    close(): void {
        this.active = false
        this.callback?.()
    }

    copyh5GameUrl(data: string) {
        if (navigator.userAgent.toLowerCase().indexOf('android') != -1) {
            this.copyFn(data)
        } else {
            clipboard.copy(data).then(() => {
                console.log('复制成功！')
                this.$toast.success('复制成功')
            })
        }
    }

    // 解决安卓手机浏览器clipboard-js复制不了的问题
    copyFn(value: string) {
        let oInput = document.createElement('input')
        oInput.value = value
        document.body.appendChild(oInput)
        oInput.select() // 选择对象
        if (document.execCommand('copy')) {
            console.log('复制成功！')
            document.execCommand('copy') // 执行浏览器复制命令
        } else {
            console.log('复制失败！')
        }
        document.body.removeChild(oInput)
    }
}
</script>

<style lang="less" scoped>
.wechat-tips-for-ios {
    position: fixed;
    z-index: 9;
    left: 0;
    width: 100%;
    color: #000;
    font-size: 16px;
    border-radius: 20px 20px 0 0;

    .main {
        padding: 20px;
        text-align: center;
    }

    img {
        width: 100%;
    }
}
</style>
